import Vue from 'vue'
import router from '@/router'
import store from '@/store/store'
import FederationUnitService from '@/services/api/FederationUnitService'

export default {
  setPeopleId({ dispatch }: any, payload: any) {
    dispatch('changePeopleId', payload)
  },
  changePeopleId({ commit, state, dispatch }: any, payload: any) {
    console.log('changePeopleId', payload)
  },
  setCurrentTour({ commit, state, dispatch }: any, payload: any) {
    commit('UPDATE_CURRENT_TOUR', payload)
  },
  setRoleModalVisibility({commit, state, dispatch}:any, payload: Boolean) {
    commit('ROLE_MODAL_VISIBILITY', payload)
  },
  disableContextMenu({commit, state, dispatch}:any) {
    commit('DISABLED_CONTEXT_MENU', false)
  },
  enableContextMenu({commit, state, dispatch}:any) {
    commit('DISABLED_CONTEXT_MENU', true)
  },
  fetchFederationUnit({ commit, state, dispatch }: any, payload: any) {
    let service: FederationUnitService = FederationUnitService.build()
    return new Promise((resolve, reject) => {
      service.all().then(
        data => {
          store.commit('common/UPDATE_FEDERATION_UNIT_LIST', data)
          resolve(data)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
